import React, { Component } from 'react';
import { toast } from "react-toastify";
import { Modal, Form, Button } from 'react-bootstrap';
import { PublicClientApplication, BrowserAuthError } from "@azure/msal-browser";

import axios from '../../../axios';
import apiError from '../../../error';
import Loader from '../../loader/loader';

export default class DmiModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: (this.props.setupType === "automatic")?"azure": this.props.type, //  will change once we will start working on google dmi 
            setupType: this.props.setupType,
            domainName: this.props.domainName,
            domainId: this.props.domainId,
            clientId: this.props.config ? this.props.config.clientId : '',
            secretId: this.props.config ? this.props.config.secretId : '',
            tanentId: this.props.config ? this.props.config.tanentId : '',
            googleServiceAccountEmail: this.props.googleServiceAccountEmail,
            googlePrivateKey: this.props.googlePrivateKey,
            testEmail: "",
            loading: false
        }
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    updateDMI = async() => {
        let payload = {
            type: this.state.type,
            domainId: this.state.domainId
        };
        
        if (this.state.type === "google") {
            // payload.googleServiceAccountEmail = this.state.googleServiceAccountEmail;
            // payload.googlePrivateKey = this.state.googlePrivateKey;
        } else {
            payload.clientId = this.state.clientId;
            payload.secretId = this.state.secretId;
            payload.tanentId = this.state.tanentId;
        }
        
        axios.post('/api/dmi/manual', payload)
            .then(res => {
                toast.success('Details Updated Successfully')
                this.props.handleClose();
                this.props.loadDomain();
            })
            .catch(err => {
                apiError(err);
            })
    }

    updateAutomaticDMI = (response) => {
        const tenantId = response.tenantId
        axios.post('/api/dmi/automatic', {
            tanentId: tenantId,
            type: this.state.type,
            domainId: this.state.domainId
        })
            .then(res => {
                toast.success('Details Updated Successfully')
                this.props.handleClose();
                this.props.loadDomain();
            })
            .catch(err => {
                apiError(err);
            })
    }
    handleLogin = async () => {
        const msalConfig = {
            auth: {
                clientId: this.props.clientId,
                authority: 'https://login.microsoftonline.com/common',
                redirectUri: window.location.origin
            }
        };

        const loginRequest = {
            scopes: [""]
        };

        if (!this.pca) {
            this.pca = new PublicClientApplication(msalConfig);
        }

        this.setState({ loading: true });

        try {
            const loginResponse = await this.pca.loginPopup(loginRequest);
            if (loginResponse) {
                const account = this.pca.getAccountByHomeId(loginResponse.account.homeAccountId);
                const msalResponse = await this.pca.acquireTokenSilent({
                    ...loginRequest,
                    account
                });

                if (msalResponse) {
                    this.updateAutomaticDMI(msalResponse);
                }
            }
        } catch (err) {
            if (err instanceof BrowserAuthError && err.errorCode === "interaction_in_progress") {
                toast.error("Multiple Login Instances Detected");
            } else {
                apiError(err);
            }
            this.setState({ loading: false });
        }
    }
    testGoogleDmi = async () => {
        try{
            if(!this.validateEmail(this.state.testEmail)){
                toast.error("Invalid email");
                return;
            }
            let testEmailDomain = this.state.testEmail.split('@')[1];
            if(testEmailDomain!==this.state.domainName){
                toast.error("Test email should be of same domain");
                return;
            }
            this.setState({loading: true});
            await axios.post('/api/dmi/manual', {
                type: this.state.type,
                domainId: this.state.domainId
            });
            let response = await axios.post('/api/dmi/test-google-dmi', {
                email: this.state.testEmail
            });
            this.setState({loading: false});
            toast.success(response.data.message);
        }catch(error){
            this.setState({loading: false});
            apiError(error);
        }
    }

    render() {

        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h5>Configure DMI</h5>
                        <p>Add your DMI configuration details</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Domain</Form.Label>
                            <Form.Control type="text" disabled value={this.state.domainName} />
                        </Form.Group>

                        <Form.Group controlId="language" className="mr-2">
                            <label>Select Domain Type</label>
                            <Form.Control as="select" disabled={this.props.setupType==="automatic"} value={this.state.type} onChange={e => {this.setState({ type: e.target.value })}}>
                                <option value="">Select</option>
                                <option value="google">Google Workspace</option>
                                <option value="azure">Office 365</option>
                            </Form.Control>
                        </Form.Group>
                        {this.state.setupType === 'manual' && this.state.type === "azure" &&
                            <>
                                <Form.Group>
                                    <Form.Label>Client Id</Form.Label>
                                    <Form.Control value={this.state.clientId} onChange={e => this.setState({ clientId: e.target.value })} type="text" placeholder="Enter Client Id" />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Secret Id</Form.Label>
                                    <Form.Control value={this.state.secretId} onChange={e => this.setState({ secretId: e.target.value })} type="text" placeholder="Enter Secret Id" />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>Tenent Id</Form.Label>
                                    <Form.Control value={this.state.tanentId} onChange={e => this.setState({ tanentId: e.target.value })} type="text" placeholder="Enter Tenent Id" />
                                </Form.Group>
                            </>
                        }
                        {this.state.setupType === 'manual' && this.state.type === "google" &&
                            // <>
                            //     <Form.Group>
                            //         <Form.Label>Service Account Email</Form.Label>
                            //         <Form.Control value={this.state.googleServiceAccountEmail} onChange={e => this.setState({ googleServiceAccountEmail: e.target.value })} type="email" placeholder="Enter service account email" />
                            //     </Form.Group>

                            //     <Form.Group>
                            //         <Form.Label>Private Key</Form.Label>
                            //         <Form.Control value={this.state.googlePrivateKey} onChange={e => this.setState({ googlePrivateKey: e.target.value })} type="text" placeholder="Enter private key" />
                            //     </Form.Group>
                            // </>
                            <>
                                <div className="noteSection">
                                    <p>Please add the following Client ID and required OAuth scope to your domain-wide delegation settings in the Google Admin Console.</p>
                                </div>
                                <Form.Group>
                                    <Form.Label>Client Id</Form.Label>
                                    <Form.Control value={this.props.googleClientId} disabled={true} type="text"/>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Scope</Form.Label>
                                    <Form.Control value={"https://www.googleapis.com/auth/gmail.insert"} disabled={true} type="text"/>
                                </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Send Test Email</Form.Label>
                                        <div style={{display: 'flex', gap: '5px'}}>
                                            <Form.Control style={{flex: '1'}} value={this.state.testEmail} type="email" placeholder='Enter test email id' onChange={(e) => this.setState({testEmail: e.target.value})}/>
                                            <Button className='btn btn-success'onClick={this.testGoogleDmi} >Save & Test</Button>
                                        </div>
                                    </Form.Group>
                            </>
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn closeBtn' onClick={this.props.handleClose}>Close</Button>
                    {this.state.setupType === "manual" ?
                        <Button className='btn btn-success' onClick={this.updateDMI}>Save</Button> :
                        <Button className='btn btn-success' onClick={this.handleLogin}>Connect</Button>
                    }
                </Modal.Footer>
                { this.state.loading? <Loader></Loader>: null }
            </Modal>
        );
    }
}